import React, { useState, useEffect } from 'react';
import { getColor } from '../statusColors';
import { apiFetch } from '../api';

const API = '/api/leads';

export default function StatusHistory({ leadId, authHeader, unitNum = null }) {
  const [history, setHistory] = useState(null);

  useEffect(() => {
    apiFetch(`${API}/${leadId}/history`, { headers: authHeader })
      .then(r => r.json())
      .then(rows => setHistory(Array.isArray(rows) ? rows : []))
      .catch(() => setHistory([]));
  }, [leadId, authHeader]);

  // 'alle' = "Ganzes Haus"-Kurzbefehl (ein Eintrag für alle Einheiten) — in jeder Einheiten-Ansicht zeigen
  const filtered = history
    ? (unitNum != null
        ? history.filter(r => String(r.unit_num) === String(unitNum) || r.unit_num === 'alle')
        : history.filter(r => r.unit_num == null))
    : null;

  if (!filtered || filtered.length === 0) {
    return (
      <div style={{ marginTop: 12 }}>
        <div className="section-label">Verlauf</div>
        <div style={{ fontSize: 12, color: '#6b7280', padding: '6px 0' }}>
          {filtered === null ? 'Lädt…' : 'Kein Verlauf vorhanden.'}
        </div>
      </div>
    );
  }

  return (
    <div style={{ marginTop: 12 }}>
      <div className="section-label">Verlauf</div>
      <div style={{ display: 'flex', flexDirection: 'column', gap: 4, marginTop: 6, maxHeight: 160, overflowY: 'auto' }}>
        {filtered.map((r, i) => {
          const color = getColor(r.status);
          const ts = r.changed_at
            ? new Date(r.changed_at.includes('T') ? r.changed_at : r.changed_at.replace(' ', 'T') + 'Z')
            : null;
          const datum = ts
            ? ts.toLocaleDateString('de-DE', { day: '2-digit', month: '2-digit', year: '2-digit', timeZone: 'Europe/Berlin' })
            : '';
          const uhrzeit = ts
            ? ts.toLocaleTimeString('de-DE', { hour: '2-digit', minute: '2-digit', timeZone: 'Europe/Berlin' })
            : '';
          return (
            <div key={i} style={{
              display: 'flex', alignItems: 'center', gap: 8,
              padding: '5px 8px', borderRadius: 6,
              background: i === 0 ? color + '12' : '#f9fafb',
              border: `1px solid ${i === 0 ? color + '40' : '#e5e7eb'}`,
              fontSize: 12,
            }}>
              <span style={{ width: 8, height: 8, borderRadius: '50%', background: color, flexShrink: 0 }} />
              <span style={{ fontWeight: 600, color, minWidth: 90 }}>{r.status}</span>
              <span style={{ color: '#6b7280', flex: 1 }}>{r.username}{r.unit_num === 'alle' && ' · ganzes Haus'}</span>
              <span style={{ color: '#6b7280', whiteSpace: 'nowrap' }}>{datum} {uhrzeit}</span>
            </div>
          );
        })}
      </div>
    </div>
  );
}
